// Olympics 2026 broadcast/streaming rights by country
// Based on official IOC broadcast rights as of Feb 2026

export interface BroadcastChannel {
  name: string;
  url?: string;
}

export interface CountryBroadcast {
  country: string;
  flag: string;
  channels: BroadcastChannel[];
  /** Short summary for inline display on game cards */
  summary: string;
}

export const olympicsBroadcasts: CountryBroadcast[] = [
  {
    country: "USA",
    flag: "🇺🇸",
    channels: [
      { name: "Peacock", url: "https://www.peacocktv.com" },
      { name: "USA Network" },
      { name: "NBC", url: "https://www.nbc.com" },
    ],
    summary: "NBC / Peacock / USA Network",
  },
  {
    country: "Canada",
    flag: "🇨🇦",
    channels: [
      { name: "CBC", url: "https://www.cbc.ca/sports" },
      { name: "TSN", url: "https://www.tsn.ca" },
      { name: "RDS", url: "https://www.rds.ca" },
      { name: "Sportsnet", url: "https://www.sportsnet.ca" },
    ],
    summary: "CBC / TSN / Sportsnet",
  },
  {
    country: "Sweden",
    flag: "🇸🇪",
    channels: [
      { name: "SVT / SVT Play", url: "https://www.svtplay.se/os-2026-ishockey" },
      { name: "TV4 / TV4 Play", url: "https://www.tv4play.se/" },
      { name: "Discovery+", url: "https://www.discoveryplus.se" },
    ],
    summary: "SVT / TV4 / Discovery+",
  },
  {
    country: "Finland",
    flag: "🇫🇮",
    channels: [
      { name: "Yle", url: "https://areena.yle.fi" },
      { name: "MTV3", url: "https://www.mtv.fi" },
      { name: "Discovery+", url: "https://www.discoveryplus.fi" },
    ],
    summary: "Yle / MTV3 / Discovery+",
  },
  {
    country: "Germany",
    flag: "🇩🇪",
    channels: [
      { name: "ARD", url: "https://www.ardmediathek.de" },
      { name: "ZDF", url: "https://www.zdf.de" },
      { name: "Eurosport", url: "https://www.eurosport.de" },
    ],
    summary: "ARD / ZDF / Eurosport",
  },
  {
    country: "Czechia",
    flag: "🇨🇿",
    channels: [
      { name: "ČT Sport", url: "https://www.ceskatelevize.cz/sport" },
      { name: "Nova Sport" },
    ],
    summary: "ČT Sport / Nova Sport",
  },
  {
    country: "Russia",
    flag: "🇷🇺",
    channels: [
      { name: "Channel One" },
      { name: "Match TV", url: "https://matchtv.ru" },
    ],
    summary: "Матч ТВ / Первый канал",
  },
  {
    country: "Europe (general)",
    flag: "🇪🇺",
    channels: [
      { name: "Eurosport", url: "https://www.eurosport.com" },
      { name: "Discovery+", url: "https://www.discoveryplus.com" },
    ],
    summary: "Eurosport / Discovery+",
  },
];

/** Top 3 broadcast summaries for compact inline display */
export const getTopBroadcastSummaries = (): { flag: string; summary: string }[] => [
  { flag: "🇪🇺", summary: "Eurosport / Discovery+" },
  { flag: "🇺🇸", summary: "NBC / Peacock" },
  { flag: "🇨🇦", summary: "CBC / TSN / Sportsnet" },
];

export const BROADCAST_DISCLAIMER =
  "Broadcast info based on official rights (as of Feb 2026). Channel assignments may vary by game – check Olympics.com or your local broadcaster for exact assignments.";
